import { AuthContext } from '@contexts/auth';
import { createContextWithSelector } from '@utils';

export const useAuth = createContextWithSelector(AuthContext, 'useAuth');
